import { render } from "./PasswordLogin.vue?vue&type=template&id=0a267ec4"
import script from "./PasswordLogin.vue?vue&type=script&lang=js"
export * from "./PasswordLogin.vue?vue&type=script&lang=js"

import "./PasswordLogin.vue?vue&type=style&index=0&id=0a267ec4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/PasswordLogin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a267ec4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a267ec4', __exports__)) {
    api.reload('0a267ec4', __exports__)
  }
  
  module.hot.accept("./PasswordLogin.vue?vue&type=template&id=0a267ec4", () => {
    api.rerender('0a267ec4', render)
  })

}


export default __exports__